<simpayx-header>
  <ion-buttons slot="start" variant="dark">
    <ion-back-button defaultHref="landing"></ion-back-button>
  </ion-buttons>
</simpayx-header>

<ion-content>
  <ion-grid class="ion-padding">
    <ion-row class="header">
      <ion-col class="header">
        <ion-back-button defaultHref="{{ backHref }}"></ion-back-button>
        <h2 class="title">
          <ion-icon name="card" style="margin-right: 10px"></ion-icon>Saved
          Cards
        </h2>
      </ion-col>
    </ion-row>
    <div class="hr"></div>

    <ion-row *ngIf="isLoading">
      <ion-col class="spinner">
        <ion-spinner name="lines"></ion-spinner>
      </ion-col>
    </ion-row>

    <ng-container  *ngIf="!isLoading && savedCards?.length > 0; else nocards">
      <ion-row *ngFor="let card of savedCards" class="saved-card">
        <ion-col size="12" class="ion-no-padding">
          <ion-card class="card-credit">
            <ion-card-content>
              <div class="card-info">
                <img [src]="getCardImage(card?.brand)" class="card-brand" />
                <span>{{ card?.name }}</span>
                <div class="card-details ion-text-end">
                  <ion-label class="card-number"
                    >**** {{ card?.last4digit }}</ion-label
                  >
                </div>
              </div>
              <div class="card-expiry-remove">
                <ion-label class="card-expiry"
                  >Exp: {{ card?.expMonth }}/{{ card?.expYear }}</ion-label
                >
                <ion-button
                  (click)="removeCards(card)"
                  fill="clear"
                  class="remove-btn"
                  color="danger"
                >
                  <ion-icon name="trash"></ion-icon> Remove
                </ion-button>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-template #nocards>
        <ion-row
          class="d-flex ion-align-items-center"
          *ngIf="!isLoading && (savedCards?.length == 0 || savedCards == null || savedCards == undefined)"
        >
          <ion-col class="spin d-flex ion-justify-content-center">
            <ion-card class="no-saved-card">
              <ion-card-content>
                <ion-label class="spx-font-16"> No saved cards! </ion-label>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
    </ng-template>
  </ion-grid>
</ion-content>
<ion-footer mode="ios">
  <ion-toolbar style="height: 25px;">
    <ion-title style="font-size: small; align-items: normal;">Powered by SimpayX</ion-title>
  </ion-toolbar>
</ion-footer>